import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=8aadf0d0&"
import script from "../../../services/admin/applicant/applicant-detail.js?vue&type=script&lang=js&"
export * from "../../../services/admin/applicant/applicant-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports